// Error pattern
/**
 * {{code}}:{
 *  {{field}}: {{translation}}
 * }
 * OR
 * {{code}}:{{translation}}
 */
export const ERROR_CODES = {
  400001: {
    name: "general.messages.unique_name_error"
  },
  // User
  100001: "password.messages.user_doesnt_exists",
  100002: "password.messages.invalid_new_password",
  100003: "password.messages.cant_update_password",
  100004: "password.messages.invalid_current_password",
  100006: "user.messages.cant_add_bloqued_user",
  100008: "user.messages.cant_find_user",
  100007: "user.messages.user_already_invited",
  100009: "user.messages.cant_get_user_organization",
  100010: "user.messages.user_already_exists",
  100011: "user.messages.cant_create_user_invite",
  100012: "user.messages.options_not_defined",
  100013: "user.messages.cant_add_user",
  100014: "user.messages.cant_accept_user_invite",
  100015: "user.messages.isnt_support_user",
  // Logs
  101001: "log.messages.not_defined_log_repository",
  101002: "log.messages.cant_create_log",
  // Organization
  102001: "organization.messages.organization_repo_not_defined",
  102002: "organization.messages.cant_get_organization",
  // Mailer
  103001: "general.messages.not_defined_mailer",
  // Team
  104001: "team.messages.repository_not_defined",
  104002: "team.messages.cant_add_user",
  104003: "team.messages.error_not_found",
  //Metadata
  105001: "metadata.messages.cant_save_static_metadata",
  105002: "metadata.messages.error_generating_hash",
  105003: "metadata.messages.error_creating",
  105004: "metadata.messages.error_upsert_in_team",
  105005: "metadata.messages.error_required_fields",
  105006: "metadata.messages.error_getting_metadata_permissions",
  105007: "metadata.messages.error_not_found",
  105008: "metadata.messages.error_not_found_customer_metadata",
  105009: "metadata.messages.error_creating_customer_metadata",
  105010: "metadata.messages.error_update_customer_metadata",
  //Template
  106001: "template.messages.cant_change_default",
  106002: "template.messages.cant_create_template",
  106003: "template.messages.error_file_upload",
  106004: "template.messages.cant_find_any_template",
  106005: "template.messages.cant_find_template",
  106006: "template.messages.cant_delete_root_template",
  106007: "template.messages.cant_delete_template",
  106008: "template.messages.cant_delete_template_items",
  106009: "template.messages.cant_set_template_root",
  106010: "template.messages.cant_set_default_false_root_template",
  106011: "template.messages.cant_change_template_root_languages",
  106012: "template.messages.cant_update_template",
  106013: "template.messages.cant_create_template_item",
  //Distribution
  107001: "distribution.messages.cant_find_distribution",
  107002: "distribution.messages.validity_inferior",
  107003: "distribution.messages.validity_less_than_answered",
  107004: "distribution.messages.cant_update_distribution",
  107005: "distribution.messages.in_process",
  //Interaction
  108001: "interaction.messages.cant_find_lanst_answered",
  //Customer
  109001: "customer.messages.error_not_found",
  109002: "customer.messages.error_found_identifier",
  109003: "customer.messages.error_duplicate_identifier",
  109004: "customer.messages.error_update_identifier"
};
